import React from "react";
import Navigation from "@/components/Navigation";
import { Calendar, MapPin, Phone } from "lucide-react";

const Location = () => {
  // Zaktualizowane godziny otwarcia
  const openingHours = [
    { day: "Poniedziałek", hours: "10:00 - 20:00" },
    { day: "Wtorek", hours: "10:00 - 20:00" },
    { day: "Środa", hours: "Zamknięte" },
    { day: "Czwartek", hours: "10:00 - 20:00" },
    { day: "Piątek", hours: "10:00 - 20:00" },
    { day: "Sobota", hours: "10:00 - 20:00" },
    { day: "Niedziela", hours: "10:00 - 20:00" },
  ];

  return (
    <div className="bg-dark min-h-screen text-gold-light">
      <Navigation />
      
      <div className="pt-32 pb-28">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold text-center mb-12 text-gold">Jak do nas trafić</h1>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-8">
              <div className="bg-dark-light p-6 rounded-lg text-center">
                <div className="flex items-center justify-center space-x-4 mb-4">
                  <MapPin className="text-gold w-6 h-6 flex-shrink-0" />
                  <h2 className="text-xl font-semibold">Lokalizacja</h2>
                </div>
                <p>Leszczynowa 20/U11</p>
                <p>76-200 Słupsk</p>
              </div>
              
              <div className="bg-dark-light p-6 rounded-lg text-center">
                <div className="flex items-center justify-center space-x-4 mb-4">
                  <Calendar className="text-gold w-6 h-6 flex-shrink-0" />
                  <h2 className="text-xl font-semibold">Godziny otwarcia</h2>
                </div>
                <div className="space-y-2">
                  {/* Zaktualizowana pętla mapująca godziny otwarcia */}
                  {openingHours.map((item) => (
                    <div key={item.day} className="flex justify-center space-x-2">
                      <span>{item.day}:</span>
                      <span>{item.hours}</span>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="bg-dark-light p-6 rounded-lg text-center mb-20">
                <div className="flex items-center justify-center space-x-4 mb-4">
                  <Phone className="text-gold w-6 h-6 flex-shrink-0" />
                  <h2 className="text-xl font-semibold">Kontakt</h2>
                </div>
                <p className="mb-8">Tel: 733 503 287</p>
                <button 
                  onClick={() => window.open("https://booksy.com/pl-pl/139856_chaba-thai-massage_masaz_20103_slupsk#ba_s=sh_1", "_blank")}
                  className="bg-gold text-dark px-6 py-2 rounded-full hover:bg-gold-dark transition-colors w-full md:w-auto"
                >
                  Zarezerwuj teraz
                </button>
              </div>
            </div>
            
            <div className="h-[600px] rounded-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2315.5518375568395!2d17.02897731608006!3d54.46427649728285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fdd4437647a6fb%3A0x724aa34ada37ff44!2sLeszczynowa%2020%2C%2076-200%20S%C5%82upsk!5e0!3m2!1spl!2spl!4v1650000000000!5m2!1spl!2spl"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Location;
